module.exports = __webpack_public_path__ + "static/media/LogoOuro.d7cc19d9.png";